import { Table } from 'react-bootstrap';
import styled from 'styled-components';

export const TableWrapper = styled(Table)`
    & > thead > tr > th {
        background-color: #133366;
        color: white;
        border: 1px solid white;
    }
    
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }
`;



export const GridWrapper = styled.div`
    height: 73vh;
    width: 100%;
    
    .ag-header-viewport {
        background-color: #133366;
    }

    .ag-header-cell {
        color: white;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 5px;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .ag-cell {
        text-align: center;
        // line-height: 40px;
        display: flex;
        justify-content: center;
    }

    .no-wrap {
        overflow: hidden;
    }

    @media screen and (max-width: 1920px) {
        .ag-header {
            font-size: 12px;
        }
        
        .ag-cell {
            font-size: 12px;
        }
    }
`;